<template>
    <div class="container bg-light position-fixed top-50 start-50 translate-middle w-75 border border-danger p-3"
        style="border-radius: 10px">
        <div class="container overflow-auto w-100" style="max-height:80vh">
            <div class="container table-responsive">
                <button class="btn-close float-end me-2 mt-1" @click.prevent="close"></button>
                <h3 class="mt-3"><strong> Información previa de la materia prima </strong></h3>
                <table class="table table-bordered my-auto mx-auto">
                    <tbody>
                        <tr>
                            <th>Nombre:</th>
                            <td rowspan="8">
                                <p class="mt-2"><strong>Imagen representativa</strong></p>
                                <img v-if="rawMaterialInfo && rawMaterialInfo.image"
                                    :src="serverUrl + 'images/forms/' + rawMaterialInfo.image" class="my-3 mx-2"
                                    style="max-width: 300px; max-height: 300px;">
                            </td>
                        </tr>
                        <tr>
                            <td><i>{{ rawMaterialInfo.name }}</i></td>
                        </tr>
                        <tr>
                            <th>Línea de la compañía asociada:</th>
                        </tr>
                        <tr>
                            <td><i>{{ rawMatType }}</i></td>
                        </tr>
                        <tr>
                            <th>Descripción:</th>
                        </tr>
                        <tr>
                            <td>{{ rawMaterialInfo.description }}</td>
                        </tr>
                        <tr>
                            <th>Orden de visualización:</th>
                        </tr>
                        <tr>
                            <td>{{ rawMaterialInfo.rawMaterialOrder }}</td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <p><strong>Nota: </strong><mark>No podrá editar la línea de la compañia asociada a la
                                        materia prima.</mark>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <h3 class=""> <strong> Editar materia prima </strong></h3>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p> <i class="requiredFields">* </i>Nuevo nombre:</p>
                            </td>
                            <td>
                                <div class="row">
                                    <div class="col-sm-6 mt-1">
                                        <input type="text" v-model="editRawMatName" class="form-control"
                                            id="edirRawMatName" />

                                    </div>
                                    <div class="col-sm-6 mt-1">
                                        <mark><input class="form-check-input" type="checkbox" role="switch"
                                                id="notChangeName" v-model="notChangeName" />
                                            <i> Mantener nombre previo.</i></mark>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p> <i class="requiredFields">* </i>Nueva descripción:</p>
                            </td>
                            <td>
                                <div class="row">
                                    <div class="col-sm-6 mt-1">
                                        <textarea type="text" v-model="editRawMatDescription" class="form-control"
                                            id="editRawMatDescrip"></textarea>
                                    </div>
                                    <div class="col-sm-6 mt-1">
                                        <mark><input class="form-check-input" type="checkbox" role="switch"
                                                id="notChangeDescrip" v-model="notChangeDescrip" />
                                            <i> Mantener descrpción previa.</i></mark>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><i class="requiredFields">* </i> Nuevo orden de visualización:</p>
                            </td>
                            <td>
                                <div class="row">
                                    <div class="col-sm-6 mt-1">
                                        <input type="number" v-model="editRawMatOrder" class="form-control" id="rawMatOrder"
                                            step="1" min="0" />
                                    </div>
                                    <div class="col-sm-6 mt-1">
                                        <mark><input class="form-check-input" type="checkbox" role="switch"
                                                id="notChangeOrder" v-model="notChangeOrder" />
                                            <i> Mantener orden de visualización previo.</i></mark>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><i class="requiredFields">* </i> Nueva imágen representativa de la materia prima:</p>
                            </td>
                            <td>
                                <div class="row">
                                    <div class="col-sm-6 mt-1">
                                        <input type="file" class="form-control" id="rawMatImage" ref="file"
                                            @change="previewFile" />
                                    </div>
                                    <div class="col-sm-6 mt-1">
                                        <mark><input class="form-check-input" type="checkbox" role="switch"
                                                id="notChangeImage" v-model="notChangeImage" />
                                            <i> Mantener imágen representativa previa.</i></mark>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <button class="btn btn-danger my-3" @click.prevent="saveChanges">
                Actualizar materia prima
            </button>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { resolveTransitionHooks } from "vue";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        getRawMaterialId: Number,
    },
    watch: {
        getRawMaterialId(newVal) {
            if (newVal !== null) {
                this.getRawMatInfo();
            }
        },
    },
    data() {
        return {
            serverUrl: RUTA_SERVIDOR,
            rawMaterialInfo: [],
            rawMatType: "",
            editRawMatName: "",
            editRawMatDescription: "",
            editRawMatOrder: 0,
            //Variables para trabajar con la imagen
            imageFile: undefined,
            currentFile: undefined,
            //Variables que pueden o no cambiar
            notChangeName: false,
            notChangeDescrip: false,
            notChangeOrder: false,
            notChangeImage: false,
        }
    },
    methods: {
        previewFile(event) {
            this.imageFile = this.$refs.file.files;
            // console.log(this.imageFile);
            this.currentFile = this.imageFile.item(0);
            // console.log(this.currentFile);
        },
        close() {
            this.$emit("hideEditRawMat", false)
        },
        async getRawMatInfo() {
            try {
                if (!this.getRawMaterialId) {
                    console.log("Raw material id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/rawMaterial/get", {
                    params: {
                        rawMat_id: this.getRawMaterialId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                this.rawMaterialInfo = res.data[0];
                // console.log(this.rawMaterialInfo);
                let type = this.rawMaterialInfo.type;
                switch (type) {
                    case "lam":
                        this.rawMatType = "Láminas";
                        break;
                    case "perf":
                        this.rawMatType = "Perfiles";
                        break;
                    case "tub":
                        this.rawMatType = "Tubos";
                        break;
                    default:
                        // En caso de que 'type' no coincida con ninguno de los casos anteriores
                        this.rawMatType = type;
                }
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
        async saveChanges() {
            if (
                (!this.notChangeName && this.editRawMatName === "") ||
                (!this.notChangeDescrip && this.editRawMatDescription === "") ||
                (!this.notChangeOrder && this.editRawMatOrder == 0) ||
                (!this.notChangeImage && this.currentFile == undefined)
            ) {
                alert("Complete aquellos campos que son obligatorios marcados con *.");
            } else {
                let formData = new FormData();
                formData.append("raw_material_id", this.getRawMaterialId);
                this.notChangeName ? formData.delete("editRawMat_name") : formData.append("editRawMat_name", this.editRawMatName);
                this.notChangeDescrip ? formData.delete("editRawMat_descrip") : formData.append("editRawMat_descrip", this.editRawMatDescription);
                this.notChangeImage ? formData.delete("editRawMat_image") : formData.append("editRawMat_image", this.currentFile);
                this.notChangeOrder ? formData.delete("editRawMat_order") : formData.append("editRawMat_order", this.editRawMatOrder);
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/rawMaterial/update",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    // console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        alert("Materia prima" + this.editRawMatName + " actualizada con exito!");
                        this.cleanfields();
                        this.close();
                        location.reload();
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
        },
        cleanfields() {
            this.editRawMatName = "";
            this.editRawMatDescription = "";
            this.rawMatOrder = 0;
            this.currentFile = undefined;
            this.notChangeName = false;
            this.notChangeDescrip = false;
            this.notChangeOrder = false;
            this.notChangeImage = false;
        },
    },
}
</script>
<style scoped>
.requiredFields {
    color: #9d0e15;
}
</style>